import * as React from 'react';
import { safeRender } from '../../../..';
import { Icon } from '@fluentui/react/lib/Icon';

import styles from './hoverIcons.scss';

export interface IconAction {
    readonly iconName: string;
    readonly onClickAction: () => void;
}

export interface Props {
    readonly iconList: IconAction[];
}

function hoverIcons(props: Props): JSX.Element {
    return (
        <div className={styles.iconContainer}>
            {props.iconList &&
                props.iconList.map(iconAction => (
                    <IconElement key={iconAction.iconName} {...iconAction} />
                ))}
        </div>
    );
}

const IconElement = (iconAction: IconAction): JSX.Element => {
    return (
        <Icon
            iconName={iconAction.iconName}
            onClick={iconAction.onClickAction}
            className={styles.icon}
        />
    );
};

export default safeRender(hoverIcons, 'HoverIcons');
